import React from 'react';

import {
	Accordion as ChakraAccordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
} from '@chakra-ui/react';

import { Heading } from '../Heading/Heading';
import { Markdown } from '../Markdown/Markdown';

export const Accordion = ({ items, ...rest }) => {
	return (
		<ChakraAccordion allowToggle mt={8} {...rest}>
			{items.map((item) => (
				<AccordionItem key={item.title} my={3} border="none">
					<Heading as="h3" color="secondary.700" className="rounded-lg shadow-lg">
						<AccordionButton>
							<Box
								flex="1"
								textAlign="left"
								fontSize="lg"
								fontWeight="semibold"
								className="leading-snug lg:leading-normal"
							>
								{item.title}
							</Box>
							<AccordionIcon w={8} h={8} />
						</AccordionButton>
					</Heading>
					<AccordionPanel color="gray.600" fontSize="lg" lineHeight={1.8} p={3}>
						<Markdown content={item.text} color="secondary.700" />
					</AccordionPanel>
				</AccordionItem>
			))}
		</ChakraAccordion>
	);
};
